import classNames from "classnames";
import { useTranslation } from "react-i18next";
import useRealtime from "../../hooks/useRealtime";

const RealtimeSection = () => {
  const { data } = useRealtime();
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  const Sections = data.rows.map((row, index) => (
    <div
      key={index}
      className={classNames(
        "bg-white shadow-md rounded-lg justify-between py-1",
        {
          "text-white bg-green-500": row.color === "G",
          "text-gray-700 bg-yellow-400": row.color === "O",
          "text-white bg-red-600": row.color == "R",
        }
      )}
    >
      <div className="text-xl leading-7 font-medium">
        {t(`type.${row.type}`)}
      </div>
      <div className="text-6xl leading-none font-bold">
        {row.value == null ? "NaN" : row.value}
      </div>
      <div className="text-xs leading-5 font-bold">Mode of last 5 seconds</div>
    </div>
  ));

  return <>{Sections}</>;
};

export default RealtimeSection;
